<template>
  <div class>
    <nav
      class="navbar navbar-expand-sm"
      style="
        padding: 20px;
        border-bottom: 1px solid #eee;
        display: block;
      "
    >
      <div class="text-center">
        <div class="btn-group m-b-10 phoneTabletMenu">
          <img v-if="showTablet == false" class="phone-tooltip" id="popover-target-1" src="static/img/surveyPreview/previewtoltip.png" />

          <button class="btn btn-default dropdown-toggle phoneBar" type="button" id="type" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="showTablet == false">
            <b-popover target="popover-target-1" triggers="hover" placement="left"> <b>Show preview</b> displays all the saved activity content you have made. Navigation at the bottom of the screen enables you to quickly go to certain pages. And options at the top of this section provide a way to switch the preview device, export options for content, and record a click-through session. </b-popover
            >Phone
          </button>
          <img v-if="showTablet" class="phone-tooltip" id="popover-target-1" src="static/img/surveyPreview/previewtoltip.png" />

          <button class="btn btn-default dropdown-toggle phoneBar" type="button" id="type" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="showTablet">
            <b-popover target="popover-target-1" triggers="hover" placement="left"> <b>Show preview</b> displays all the saved activity content you have made. Navigation at the bottom of the screen enables you to quickly go to certain pages. And options at the top of this section provide a way to switch the preview device, export options for content, and record a click-through session. </b-popover
            >Tablet
          </button>
          <div class="dropdown-menu phone-tablet-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" vakue id="phone-selected" v-on:click="toggleTablet('phone')" selected> <img src="static/img/surveyPreview/phone.png" />&nbsp;&nbsp; Phone </a>
            <a class="dropdown-item" id="tablet-selected" v-on:click="toggleTablet('tablet')"> <img src="static/img/surveyPreview/tablet.png" />&nbsp; Tablet </a>
          </div>
        </div>

        <div class="btn-group m-b-10 exportBtn">
          <a class="btn btn-default dropdown-toggle" role="button" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Export</a>
          <div class="dropdown-menu exportDropdown" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" v-on:click="exportScreen()"> <img src="static/img/surveyPreview/exportscreen.png" />&nbsp;Export Step </a>
            <a class="dropdown-item" v-on:click="exportSurveyPdf()"> <img src="static/img/surveyPreview/exportsurvey.png" />&nbsp;Export PDF </a>
            <a class="dropdown-item" v-on:click="printScreen()"> <img src="static/img/surveyPreview/print.png" />&nbsp; Print Step </a>
            <a class="dropdown-item" v-on:click="printSurvey()"> <img src="static/img/surveyPreview/print.png" />&nbsp; Print Activity </a>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </nav>
    <!--Phone frame design START---->
    <div v-if="showTablet == false" id="phone-frame">
      <div class="phone-frame1">
        &nbsp;
        <!-- <div style="padding-top: 15px;"> -->
        <div class="phone-inner-part">
          <div class="phone-top-bar">
            <i class="fa fa-wifi wifi-icon" style="float: left"></i>
            <strong style="font-size: 11px; margin-left: 40%">9:41 AM</strong>
            <i class="fa fa-battery-half" style="float: right" aria-hidden="true"></i>

            <div class="phone-top-bar">
              <i class="fa fa-chevron-left"></i>
              <span class="top-content-name text-center">
                <b>{{ activityData.name }}</b>
              </span>
              <hr />

              <div v-if="phoneQuestion" class="phone-question d-block" :class="{ 'no-footer': !!activityData.customFooter == false }" id="questionbpodyy">
                <!-- code for different screen type START--->
                <div v-if="phoneQuestion.type == 'SurveyInstruction'">
                  <div class="pl-0 text-center mt-5 pt-5 pb-15">
                    <div class="row instruction_title text-left mt-5 pt-5" v-html="phoneQuestion.formattedTitle"></div>
                    <div v-if="phoneQuestion.previewImageUrl" class="imageBox">
                      <img class="img-size" :src="phoneQuestion.previewImageUrl" />
                    </div>
                    <div class="row instruction_info text-left mt-5 pt-5" v-html="phoneQuestion.formattedInformation"></div>
                  </div>
                </div>
                <!-- Log Entry Question Preview START -->
                <div class="option-section pad-top20" v-if="displayOnlyTitleSteps.indexOf(phoneQuestion.type) >= 0">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Log Entry Question Preview END -->
                <div class="option-section pad-top20" v-if="phoneQuestion.type == 'CustomScale' && phoneQuestion.direction == 'Vertical'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <ds-slider
                            :value="getDefaultPositionValueForCustomScale(phoneQuestion)"
                            v-if="phoneQuestion.verticalScale"
                            ref="slider"
                            :piecewise="true"
                            width="2"
                            direction="vertical"
                            tooltip="none"
                            class="vertical-vue-slider pl-20"
                            :data="phoneQuestion.formattedLabels"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :piecewiseActiveStyle="null"
                            :labelActiveStyle="null"
                            :dotSize="0"
                            style="text-align: -webkit-center"
                          ></ds-slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'CustomScale' && phoneQuestion.direction == 'Horizontal'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <ds-slider
                            :value="getDefaultPositionValueForCustomScale(phoneQuestion)"
                            v-if="!phoneQuestion.verticalScale"
                            ref="slider"
                            :piecewise="true"
                            width="1"
                            direction="horizontal"
                            tooltip="none"
                            class="horizontal-vue-slider pl-20"
                            :data="phoneQuestion.formattedLabels"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :piecewiseActiveStyle="null"
                            :labelActiveStyle="null"
                            :dotSize="0"
                          ></ds-slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'DateTime'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <input type="text" class="input-text readonly" :placeholder="getPlaceHolderText(phoneQuestion)" readonly />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'Image'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body text-center step-img-format">
                          <div v-for="(languageImageOptions, loopIndex) in phoneQuestion.languageImageOptions" :key="loopIndex">
                            <div v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex" class="form-group">
                              <img class="imageBox pl-0 text-center img-size" :src="option.previewImageUrl" />
                            </div>
                          </div>
                          <div>
                            <div v-if="phoneQuestion.isDisplayOtherOptionContentField">
                              <span maxlength="10">{{ phoneQuestion.otherOptionContentField }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'MultiChoice'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <div class v-for="(img, index) in phoneQuestion.bodyImages" :key="index">
                            <img :src="img.previewImageUrl" alt class="img-size" />
                          </div>
                          <div v-for="(option, index) in phoneQuestion.options" :key="index" v-bind:value="option.formattedBody">
                            <input type="radio" class disabled />
                            <label class="ml-5 pt-10" v-html="option.formattedBody"></label>
                          </div>
                          <div>
                            <div v-if="phoneQuestion.isDisplayOtherOptionContentField">
                              <input type="radio" disabled />
                              <span class="ml-5">{{ phoneQuestion.otherOptionContentField }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'DropDown'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <div class v-for="(img, index) in phoneQuestion.bodyImages" :key="index">
                            <img :src="img.previewImageUrl" alt class="img-size" />
                          </div>
                          <select class="drop-down" disabled>
                            <option value="undefined" selected disabled>Select an answer</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'Number'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <input type="text" class="input-text readonly" :placeholder="[[this.phoneQuestion.units]] + ' ' + 'Enter a number ' + [[this.phoneQuestion.minValue]] + '' + '-' + [[this.phoneQuestion.maxValue]]" readonly />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'NumberScale' && phoneQuestion.direction == 'Horizontal'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body text-center">
                          <div :class="phoneQuestion.numericRatingScale ? 'd-inline-block' : ''">
                            <div class="d-flex flex-column">
                              <ds-slider
                                ref="slider"
                                v-if="phoneQuestion.partitions !== 0"
                                :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue"
                                :piecewise="true"
                                direction="horizontal"
                                tooltip="none"
                                class="horizontal-vue-slider pl-5 number-scale-box"
                                :min="phoneQuestion.minValue"
                                :max="phoneQuestion.maxValue"
                                :disabled="true"
                                :piecewiseLabel="true"
                                :piecewiseStyle="piecewiseStyle"
                                :interval="phoneQuestion.partitions"
                                :piecewiseActiveStyle="null"
                                :labelActiveStyle="null"
                                :dotSize="0"
                                :isNumericRatingScale="phoneQuestion.numericRatingScale"
                              ></ds-slider>
                              <ds-slider ref="slider" v-else :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue" direction="horizontal" tooltip="none" class="horizontal-vue-slider pl-5 number-scale-box" :min="phoneQuestion.minValue" :max="phoneQuestion.maxValue" :disabled="true" :labelActiveStyle="null" :dotSize="0"> </ds-slider>
                              <div class="pt-10 scaleLabels d-flex justify-content-between textBreak p-0">
                                <div class="label wordbrk text-left">
                                  {{ phoneQuestion.minValueLabel }}
                                </div>
                                <div class="text-right label wordbrk">
                                  {{ phoneQuestion.maxValueLabel }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="option-section pad-top20" v-if="phoneQuestion.type == 'NumberScale' && phoneQuestion.direction == 'Vertical'">
                  <div class="modal bs-example-modal text-center">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body text-center">
                          <div class="scaleLabels">
                            {{ phoneQuestion.maxValueLabel }}
                          </div>
                          <ds-slider
                            ref="slider"
                            v-if="phoneQuestion.partitions !== 0"
                            :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue"
                            :piecewise="true"
                            direction="vertical"
                            tooltip="none"
                            class="vertical-vue-slider pt-15"
                            :class="{ 'v-number-scale-steps': !phoneQuestion.numericRatingScale }"
                            width="1"
                            :min="phoneQuestion.minValue"
                            :max="phoneQuestion.maxValue"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :interval="phoneQuestion.partitions"
                            :piecewiseActiveStyle="null"
                            :labelActiveStyle="null"
                            :dotSize="0"
                            :isNumericRatingScale="phoneQuestion.numericRatingScale"
                            style="text-align: -webkit-center"
                            :defaultSelected="false"
                          ></ds-slider>
                          <ds-slider
                            ref="slider"
                            v-else
                            :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue"
                            direction="vertical"
                            tooltip="none"
                            class="vertical-vue-slider pl-20"
                            width="2"
                            :min="phoneQuestion.minValue"
                            :max="phoneQuestion.maxValue"
                            :disabled="true"
                            :labelActiveStyle="null"
                            :dotSize="0"
                            :isNumericRatingScale="phoneQuestion.numericRatingScale"
                            :defaultSelected="false"
                          ></ds-slider>
                          <div class="scaleLabels">
                            {{ phoneQuestion.minValueLabel }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="phoneQuestion.type == 'VAS' && phoneQuestion.direction == 'Horizontal'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body w-auto">
                          <div class="pull-left vas-minValueLabel">
                            {{ phoneQuestion.minValueLabel }}
                          </div>
                          <div class="pull-right vas-maxValueLabel">
                            {{ phoneQuestion.maxValueLabel }}
                          </div>
                          <div class="clearfix"></div>
                          <ds-slider ref="slider" :value="phoneQuestion.minValue" direction="horizontal" class="horizontal-vue-slider pl-20" tooltip="none" :width="auto" :min="phoneQuestion.minValue" :max="phoneQuestion.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                          <div class="pull-left pl-10 vas-minValueLabel">
                            {{ phoneQuestion.minValue }}
                          </div>
                          <div class="pull-left vas-maxValueLabel">
                            {{ phoneQuestion.maxValue }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="option-section pad-top20" v-if="phoneQuestion.type == 'VAS' && phoneQuestion.direction == 'Vertical'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body text-center" style="height: 280px;">
                          <div class="scaleLabels">
                            <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.maxValue }}</span>
                            <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.maxValueLabel }}</span>
                          </div>
                          <div v-if="phoneQuestion.isScaleType" class="vas_result_label">
                            <span>{{ phoneQuestion.resultLabel }}</span>
                          </div>
                          <ds-slider
                            ref="slider"
                            :value="phoneQuestion.minValue"
                            direction="vertical"
                            tooltip="none"
                            class="pl-20"
                            width="2"
                            :height="phoneQuestion.restrainLengthValue <= 55 ? phoneQuestion.restrainLengthValue + 'mm' : 55 + 'mm'"
                            :min="phoneQuestion.minValue"
                            :max="phoneQuestion.maxValue"
                            :disabled="true"
                            :labelActiveStyle="labelActiveStyle"
                            style="text-align: -webkit-center"
                          ></ds-slider>
                          <div v-if="phoneQuestion.verticalScale">
                            <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.minValue }}</span>
                            <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.minValueLabel }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="phoneQuestion.type == 'Text'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <input type="text" class="input-text readonly" placeholder="Answer" readonly />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'Measurements'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <div class="d-flex  align-items-center" v-if="phoneQuestion.measurementUnit != 'Feet-Inches' && phoneQuestion.subType != 'bloodpressure' && phoneQuestion.subType != 'measurements'">
                            <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                            <span class="ml-10">{{ phoneQuestion.measurementUnit }}</span>
                          </div>
                          <div v-if="phoneQuestion.measurementUnit == 'Feet-Inches'">
                            <div class="d-flex mb-10 align-items-center">
                              <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                              <span class="ml-5 mr-5">ft</span>
                            </div>
                            <div class="d-flex align-items-center">
                              <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                              <span class="ml-5">in</span>
                            </div>
                          </div>
                          <div v-if="phoneQuestion.subType === 'bloodpressure'">
                            <div class="d-flex mb-10 align-items-center">
                              <input type="text" class="input-text readonly" placeholder="Systolic" readonly />
                              <span class="ml-10 mr-2">/</span>

                              <input type="text" class="input-text readonly" placeholder="Diastolic" readonly />
                              <span class="ml-10 mr-2">mmHg</span>
                            </div>
                          </div>
                          <div class="d-flex" v-if="phoneQuestion.subType === 'measurements'">
                            <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                            <span class="ml-10 mr-2 mt-7">{{ phoneQuestion.measurementUnit }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'Boolean'">
                  <div class="modal bs-example-modal">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                        </div>
                        <div class="modal-body">
                          <div v-for="(option, index) in phoneQuestion.options.slice(0, 4)" :key="index" v-bind:value="option.formattedBody">
                            <input type="radio" class disabled />
                            <label class="ml-5 pt-10" v-html="option.formattedBody"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'ImageCapture'">
                  <div class="pl-0 text-center mt-5 pt-5">
                    <div v-if="phoneQuestion.previewImageUrl" class="imageBox">
                      <img class="img-size" :src="phoneQuestion.previewImageUrl" />
                    </div>
                    <div class="row instruction_title text-left mt-5 pt-5" v-html="phoneQuestion.formattedTitle"></div>
                    <div class="row instruction_info text-left mt-5 pt-5" v-html="phoneQuestion.formattedInformation"></div>
                  </div>
                </div>

                <div v-if="phoneQuestion.type == 'SurveyCompletion'">
                  <div class="text-center" v-html="phoneQuestion.formattedTitle" />
                  <div class="text-center" v-if="phoneQuestion.imageUrl">
                    <img class="img-size" :src="phoneQuestion.imageUrl" />
                  </div>
                </div>

                <div v-if="phoneQuestion.type == 'AudioRecording'">
                  <div class="text-left instruction_title ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                  <div class="instruction_info step-img-format text-left ql-editor pt-0 p-0" v-html="phoneQuestion.formattedInformation" />
                </div>

                <div v-if="phoneQuestion.type == 'VideoRecording'">
                  <div class="text-left instruction_title ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                  <div class="instruction_info step-img-format text-left ql-editor pt-0 p-0" v-html="phoneQuestion.formattedInformation" />
                </div>

                <div v-if="phoneQuestion.type == 'GPSkin'">
                  <div class="text-left step-img-format ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                  <div class="row instruction_info text-left mt-5 pt-5" v-html="phoneQuestion.formattedInformation"></div>
                  <div v-if="phoneQuestion.imageUrl" class="imageBox">
                    <img class="img-size" :src="phoneQuestion.imageUrl" />
                  </div>
                  <div class="pl-0 text-center mt-5 pt-5">
                    <a href="#" v-if="(phoneQuestion.isSkippable = false)" class="text-center mt-5 pt-5 disabled-footer" style="display: block">Skip this question</a>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'ValidatedEntry'">
                  <div class="text-left wong-baker-title-text" v-html="phoneQuestion.formattedBody" />
                </div>
                <div v-if="phoneQuestion.type == 'WongBaker'">
                  <div class="text-left wong-baker-title-text ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                  <div class="row">
                    <img width="100%" height="145px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="d-block text-center" alt="hurts-worse.svg" />
                  </div>
                  <div class="wong-baker-count-box">
                    <p class="count-text">6</p>
                  </div>
                </div>
                <div v-if="phoneQuestion.type == 'MedicationSelector'">
                  <div class="text-left ql-editor pt-0 p-0" v-html="phoneQuestion.formattedBody" />
                  <div class="col-md-12 col-sm-12 col-12 p-0 pt-15 table-overflow" v-if="phoneQuestion.content != '[]' && phoneQuestion.content[0] != undefined && phoneQuestion.content[0]['options'] != undefined">
                    <!--Start of Static Table Structure -->
                    <div class="medication_selector_table_container">
                      <div class="row table_heading">
                        <div class="col-md-4 text-center border padding">Category</div>
                        <div class="col-md-4 text-center border padding">Medication</div>
                        <div class="col-md-4 text-center border padding">Dosage</div>
                      </div>
                      <table class="medication_selector_table1">
                        <tbody>
                          <span v-for="(option, ind) in phoneQuestion.content[0]['options']" :key="ind">
                            <tr v-for="(dosage, index) in option['dosage']" :key="index">
                              <td v-if="index == 0">{{ option["category"] }}</td>
                              <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                              <td v-if="index == 0">{{ option["name"] }}</td>
                              <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                              <td>{{ dosage }}</td>
                            </tr>
                          </span>
                        </tbody>
                      </table>
                    </div>
                    <!--End of Static Table Structure-->
                  </div>
                </div>

                <!-- Skin Analyser Question Preview START -->
                <div v-if="phoneQuestion.type == 'SkinAnalyser'">
                  <div class="pl-0 text-center mt-5 pt-5">
                    <div class="row instruction_title text-left mt-5 pt-5" v-html="phoneQuestion.formattedTitle"></div>
                    <div class="row instruction_info text-left mt-5 pt-5" v-html="phoneQuestion.formattedInformation"></div>
                    <div v-if="phoneQuestion.imageUrl" class="imageBox">
                      <img class="img-size" :src="phoneQuestion.imageUrl" />
                    </div>
                  </div>
                </div>
                <!-- Skin Analyser Question Preview END  -->

                <!-- code for different screen type END--->
                <div v-if="activityData.customFooter" class="text-center fs-11" v-html="activityData.customFooterText"></div>
              </div>
              <div v-if="phoneQuestion" class="phone-question-footer">
                <div class="mt-5 pt-3">
                  <a href="#" class="btn next-button disabled-footer">Next</a>
                  <a href="#" v-if="phoneQuestion.isSkippable" class="text-center mt-5 pt-2 disabled-footer" style="display: block">Skip this question</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!--Phone frame design END---->

    <!--Tablet frame design ---->
    <div id="tablet-frame" v-if="showTablet">
      <div class="tablet-frame1">
        <div>
          &nbsp;
          <div class="tablet-inner-part">
            <div class="phone-top-bar">
              <i class="fa fa-wifi" style="float: left"></i>
              <strong style="font-size: 11px; margin-left: 40%">9:41 AM</strong>
              <i class="fa fa-battery-half" aria-hidden="true" style="float: right"></i>
            </div>
            <div class="phone-top-bar">
              <i class="fa fa-chevron-left"></i>
              <span class="top-content-name text-center">
                <b>{{ activityData.name }}</b>
              </span>
            </div>
            <hr />
            <div v-if="phoneQuestion" class="tablet-question d-block" :class="{ 'no-footer': !!activityData.customFooter == false }" id="questionbpodyy">
              <!-- code for different screen type START--->
              <div v-if="phoneQuestion.type == 'SurveyInstruction'">
                <div class="pl-15 pr-15 pb-15 text-center mt-5 pt-5">
                  <div class="row instruction_title text-left mt-5 pt-5" v-html="phoneQuestion.formattedTitle"></div>
                  <div v-if="phoneQuestion.previewImageUrl" class="imageBox">
                    <img class="img-size" :src="phoneQuestion.previewImageUrl" />
                  </div>
                  <div class="row instruction_info text-left mt-5 pt-5" v-html="phoneQuestion.formattedInformation"></div>
                </div>
              </div>
              <!-- Log Entry Question Preview START -->
              <div class="option-section pad-top20" v-if="displayOnlyTitleSteps.indexOf(phoneQuestion.type) >= 0">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Log Entry Question Preview END -->
              <div class="option-section pad-top20" v-if="phoneQuestion.type == 'CustomScale' && phoneQuestion.direction == 'Vertical'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <ds-slider
                          :value="getDefaultPositionValueForCustomScale(phoneQuestion)"
                          v-if="phoneQuestion.verticalScale"
                          ref="slider"
                          :piecewise="true"
                          width="2"
                          direction="vertical"
                          tooltip="none"
                          class="vertical-vue-slider pl-20"
                          :data="phoneQuestion.formattedLabels"
                          :disabled="true"
                          :piecewiseLabel="true"
                          :piecewiseStyle="piecewiseStyle"
                          :piecewiseActiveStyle="null"
                          :labelActiveStyle="null"
                          :dotSize="0"
                          style="text-align: -webkit-center"
                        ></ds-slider>
                      </div>
                      <!-- <div v-html="phoneQuestion.scalePoint">
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'CustomScale' && phoneQuestion.direction == 'Horizontal'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <ds-slider
                          :value="getDefaultPositionValueForCustomScale(phoneQuestion)"
                          v-if="!phoneQuestion.verticalScale"
                          ref="slider"
                          :piecewise="true"
                          width="1"
                          direction="horizontal"
                          tooltip="none"
                          class="horizontal-vue-slider pl-20"
                          :data="phoneQuestion.formattedLabels"
                          :disabled="true"
                          :piecewiseLabel="true"
                          :piecewiseStyle="piecewiseStyle"
                          :piecewiseActiveStyle="null"
                          :labelActiveStyle="null"
                          :dotSize="0"
                        ></ds-slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'DateTime'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <input type="text" class="input-text readonly" :placeholder="getPlaceHolderText(phoneQuestion)" readonly />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'Image'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body text-center step-img-format">
                        <div class="row justify-content-start">
                          <div class="col-auto pl-0 pr-0" v-for="(languageImageOptions, loopIndex) in phoneQuestion.languageImageOptions" :key="loopIndex">
                            <div class="form-group" v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex">
                              <img class="imageBox pl-0 text-center img-size" :src="option.previewImageUrl" />
                            </div>
                          </div>
                        </div>
                        <div>
                          <div v-if="phoneQuestion.isDisplayOtherOptionContentField">
                            <span>{{ phoneQuestion.otherOptionContentField }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'MultiChoice'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <div class v-for="(img, index) in phoneQuestion.bodyImages" :key="index">
                          <img :src="img.previewImageUrl" alt class="img-size" />
                        </div>
                        <div v-for="(option, index) in phoneQuestion.options" :key="index" v-bind:value="option.formattedBody">
                          <input type="radio" class disabled />
                          <label class="ml-5 pt-10" v-html="option.formattedBody"></label>
                        </div>
                        <div>
                          <div v-if="phoneQuestion.isDisplayOtherOptionContentField">
                            <input type="radio" class disabled />
                            <span class="ml-5">{{ phoneQuestion.otherOptionContentField }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'DropDown'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <div class v-for="(img, index) in phoneQuestion.bodyImages" :key="index">
                          <img :src="img.previewImageUrl" alt class="img-size" />
                        </div>
                        <select class="drop-down" disabled>
                          <option value="undefined" selected disabled>Select an answer</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'Number'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <input type="text" class="input-text readonly" :placeholder="[[this.phoneQuestion.units]] + ' ' + 'Enter a number ' + [[this.phoneQuestion.minValue]] + '' + '-' + [[this.phoneQuestion.maxValue]]" readonly />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'NumberScale' && phoneQuestion.direction == 'Horizontal'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <div class="modal-body text-center">
                          <div :class="phoneQuestion.numericRatingScale ? 'd-inline-block' : ''">
                            <div class="d-flex flex-column">
                              <ds-slider
                                ref="slider"
                                v-if="phoneQuestion.partitions !== 0"
                                :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue"
                                :piecewise="true"
                                direction="horizontal"
                                tooltip="none"
                                class="horizontal-vue-slider pl-5 number-scale-box"
                                :min="phoneQuestion.minValue"
                                :max="phoneQuestion.maxValue"
                                :disabled="true"
                                :piecewiseLabel="true"
                                :piecewiseStyle="piecewiseStyle"
                                :interval="phoneQuestion.partitions"
                                :piecewiseActiveStyle="piecewiseActiveStyle"
                                :labelActiveStyle="labelActiveStyle"
                                :isNumericRatingScale="phoneQuestion.numericRatingScale"
                                :dotSize="0"
                              ></ds-slider>
                              <ds-slider ref="slider" v-else :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue" direction="horizontal" tooltip="none" class="horizontal-vue-slider pl-5 number-scale-box" :min="phoneQuestion.minValue" :max="phoneQuestion.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                              <div class="pt-10 scaleLabels d-flex justify-content-between textBreak p-0">
                                <div class="text-justify label wordbrk">
                                  {{ phoneQuestion.minValueLabel }}
                                </div>
                                <div class="text-right label wordbrk">
                                  {{ phoneQuestion.maxValueLabel }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="option-section pad-top20" v-if="phoneQuestion.type == 'NumberScale' && phoneQuestion.direction == 'Vertical'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body text-center">
                        <div class="scaleLabels">
                          {{ phoneQuestion.maxValueLabel }}
                        </div>
                        <ds-slider
                          ref="slider"
                          v-if="phoneQuestion.partitions !== 0"
                          :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue"
                          :piecewise="true"
                          direction="vertical"
                          tooltip="none"
                          class="vertical-vue-slider pt-15"
                          :class="{ 'v-number-scale-steps': !phoneQuestion.numericRatingScale }"
                          width="2"
                          :min="phoneQuestion.minValue"
                          :max="phoneQuestion.maxValue"
                          :disabled="true"
                          :piecewiseLabel="true"
                          :piecewiseStyle="piecewiseStyle"
                          :interval="phoneQuestion.partitions"
                          :piecewiseActiveStyle="piecewiseActiveStyle"
                          :labelActiveStyle="labelActiveStyle"
                          :isNumericRatingScale="phoneQuestion.numericRatingScale"
                          style="text-align: -webkit-center"
                          :dotSize="0"
                        ></ds-slider>
                        <ds-slider ref="slider" v-else :value="phoneQuestion.defaultPointerPosition == 'max' ? phoneQuestion.maxValue : phoneQuestion.minValue" direction="vertical" tooltip="none" class="vertical-vue-slider pl-20" width="2" :min="phoneQuestion.minValue" :max="phoneQuestion.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                        <div class="scaleLabels" v-if="phoneQuestion.verticalScale">
                          {{ phoneQuestion.minValueLabel }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="phoneQuestion.type == 'VAS' && phoneQuestion.direction == 'Horizontal'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <div class="pull-left">
                          {{ phoneQuestion.minValueLabel }}
                        </div>
                        <div
                          class="pull-left"
                          :style="{
                            'margin-left': phoneQuestion.restrainLengthValue <= 85 ? phoneQuestion.restrainLengthValue - 10 + 'mm' : 75 + 'mm'
                          }"
                        >
                          {{ phoneQuestion.maxValueLabel }}
                        </div>
                        <div class="p-10"></div>
                        <ds-slider ref="slider" :value="phoneQuestion.minValue" direction="horizontal" class="horizontal-vue-slider pl-20" tooltip="none" :width="phoneQuestion.restrainLengthValue <= 85 ? phoneQuestion.restrainLengthValue + 'mm' : 85 + 'mm'" :min="phoneQuestion.minValue" :max="phoneQuestion.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                        <div class="pull-left pl-10">
                          {{ phoneQuestion.minValue }}
                        </div>
                        <div
                          class="pull-left"
                          :style="{
                            'margin-left': phoneQuestion.restrainLengthValue <= 85 ? phoneQuestion.restrainLengthValue - 10 + 'mm' : 75 + 'mm'
                          }"
                        >
                          {{ phoneQuestion.maxValue }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="option-section pad-top20" v-if="phoneQuestion.type == 'VAS' && phoneQuestion.direction == 'Vertical'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body text-center" style="height: 255px;">
                        <div class="scaleLabels">
                          <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.maxValue }}</span>
                          <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.maxValueLabel }}</span>
                        </div>
                        <div v-if="phoneQuestion.isScaleType" class="vas_result_label">
                          <span>{{ phoneQuestion.resultLabel }}</span>
                        </div>
                        <ds-slider
                          ref="slider"
                          :value="phoneQuestion.minValue"
                          direction="vertical"
                          tooltip="none"
                          class="pl-20"
                          width="2"
                          :height="phoneQuestion.restrainLengthValue <= 50 ? phoneQuestion.restrainLengthValue + 'mm' : 50 + 'mm'"
                          :min="phoneQuestion.minValue"
                          :max="phoneQuestion.maxValue"
                          :disabled="true"
                          :labelActiveStyle="labelActiveStyle"
                          style="text-align: -webkit-center"
                        ></ds-slider>
                        <div v-if="phoneQuestion.verticalScale">
                          <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.minValue }}</span>
                          <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ phoneQuestion.minValueLabel }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="phoneQuestion.type == 'Text'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <input type="text" class="input-text readonly" placeholder="Answer" readonly />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'Measurements'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <div class="d-flex  align-items-center" v-if="phoneQuestion.measurementUnit != 'Feet-Inches' && phoneQuestion.subType != 'bloodpressure' && phoneQuestion.subType != 'measurements'">
                          <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                          <span class="ml-10" v-if="phoneQuestion.subType === 'bloodpressure'">/</span>
                          <span class="ml-10" v-else>{{ phoneQuestion.measurementUnit }}</span>
                        </div>
                        <div class="d-flex align-items-center" v-if="phoneQuestion.measurementUnit == 'Feet-Inches'">
                          <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                          <span class="ml-5 mr-5">ft</span>
                          <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                          <span class="ml-5">in</span>
                        </div>
                        <div v-if="phoneQuestion.subType === 'bloodpressure'">
                          <div class="d-flex align-items-center mb-10">
                            <input type="text" class="input-text readonly" placeholder="Systolic" readonly />
                            <span class="ml-10 mr-2">/</span>
                            <input type="text" class="input-text readonly" placeholder="Diastolic" readonly />
                            <span class="ml-10 mr-2">mmHg</span>
                          </div>
                        </div>
                        <div class="d-flex" v-if="phoneQuestion.subType === 'measurements'">
                          <input type="text" class="input-text readonly" :placeholder="getPlaceHolderTextMeasurement(phoneQuestion)" readonly />
                          <span class="ml-10 mr-2 mt-7">{{ phoneQuestion.measurementUnit }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="phoneQuestion.type == 'Boolean'">
                <div class="modal bs-example-modal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <div class="modal-title" v-html="phoneQuestion.formattedBody" />
                      </div>
                      <div class="modal-body">
                        <div v-for="(option, index) in phoneQuestion.options.slice(0, 4)" :key="index" v-bind:value="option.formattedBody">
                          <input type="radio" class disabled />
                          <label class="ml-5 pt-10" v-html="option.formattedBody"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'ImageCapture'">
                <div class="pl-0 text-center mt-5 pt-5">
                  <div v-if="phoneQuestion.previewImageUrl" class="imageBox">
                    <img class="img-size" :src="phoneQuestion.previewImageUrl" />
                  </div>
                  <div class="row instruction_title text-left mt-5 pt-5" v-html="phoneQuestion.formattedTitle"></div>
                  <div class="row instruction_info text-left mt-5 pt-5" v-html="phoneQuestion.formattedInformation"></div>
                </div>
              </div>

              <div v-if="phoneQuestion.type == 'SurveyCompletion'">
                <div class="text-center" v-html="phoneQuestion.formattedTitle" />
                <div class="text-center" v-if="phoneQuestion.imageUrl">
                  <img class="img-size" :src="phoneQuestion.imageUrl" />
                </div>
              </div>

              <div v-if="phoneQuestion.type == 'AudioRecording'">
                <div class="text-left instruction_title ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                <div class="instruction_info step-img-format text-left ql-editor pt-0 p-0" v-html="phoneQuestion.formattedInformation" />
              </div>

              <div v-if="phoneQuestion.type == 'VideoRecording'">
                <div class="text-left instruction_title ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                <div class="instruction_info step-img-format text-left ql-editor pt-0 p-0" v-html="phoneQuestion.formattedInformation" />
              </div>

              <div v-if="phoneQuestion.type == 'GPSkin'">
                <div class="text-left step-img-format ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                <div class="pl-0 text-center mt-5 pt-5">
                  <a href="#" v-if="(phoneQuestion.isSkippable = false)" class="text-center mt-5 pt-5 disabled-footer" style="display: block">Skip this question</a>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'ValidatedEntry'">
                <div class="text-left" v-html="phoneQuestion.formattedBody" />
              </div>
              <div v-if="phoneQuestion.type == 'WongBaker'">
                <div class="text-left ql-editor pt-0 p-0" v-html="phoneQuestion.formattedTitle" />
                <div class="row">
                  <img width="100%" height="145px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="d-block text-center" alt="hurts-worse.svg" />
                </div>
                <div class="wong-baker-count-box">
                  <p class="count-text">6</p>
                </div>
              </div>
              <div v-if="phoneQuestion.type == 'MedicationSelector'">
                <div class="text-left ql-editor pt-0 p-0" v-html="phoneQuestion.formattedBody" />
                <div class="col-md-6 col-md-12 col-sm-12 col-12 p-0 pt-15 table-overflow p-0 pt-15" v-if="phoneQuestion.content != '[]' && phoneQuestion.content[0] != undefined && phoneQuestion.content[0]['options'] != undefined">
                  <!--Start of Static Table Structure -->
                  <div class="medication_selector_table_container">
                    <div class="row table_heading">
                      <div class="col-md-4 text-center border padding">Category</div>
                      <div class="col-md-4 text-center border padding">Medication</div>
                      <div class="col-md-4 text-center border padding">Dosage</div>
                    </div>
                    <table class="medication_selector_table1">
                      <tbody>
                        <span v-for="(option, ind) in phoneQuestion.content[0]['options']" :key="ind">
                          <tr v-for="(dosage, index) in option['dosage']" :key="index">
                            <td v-if="index == 0">{{ option["category"] }}</td>
                            <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                            <td v-if="index == 0">{{ option["name"] }}</td>
                            <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                            <td>{{ dosage }}</td>
                          </tr>
                        </span>
                      </tbody>
                    </table>
                  </div>
                  <!--End of Static Table Structure-->
                </div>
              </div>
              <!-- Skin Analyser Question Preview START -->
              <div v-if="phoneQuestion.type == 'SkinAnalyser'">
                <div class="pl-0 text-center mt-5 pt-5 m-10">
                  <div class="row instruction_title text-left mt-5 pt-5" v-html="phoneQuestion.formattedTitle"></div>
                  <div class="row instruction_info text-left mt-5 pt-5" v-html="phoneQuestion.formattedInformation"></div>
                  <div v-if="phoneQuestion.imageUrl" class="imageBox mt-10">
                    <img class="img-size" :src="phoneQuestion.imageUrl" />
                  </div>
                </div>
              </div>
              <!-- Skin Analyser Question Preview END -->
              <!-- code for different screen type END--->
              <div v-if="activityData.customFooter" class="text-center fs-11" v-html="activityData.customFooterText"></div>
            </div>
            <div v-if="phoneQuestion" class="tablet-question-footer">
              <div class="mt-5 pt-3">
                <a href="#" class="btn next-button disabled-footer">Next</a>
                <a href="#" v-if="phoneQuestion.isSkippable" class="text-center mt-5 pt-5 disabled-footer" style="display: block">Skip this question</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Tablet frame design END---->
    <!--pagination code-->
    <div class="preview-footer text-center">
      <button id="prevButton" class="mobile-pagination" name="Prev" v-on:click="prevMobileQuestion()">
        <i class="fa fa-chevron-left"></i>
      </button>
      <span class="m-5" v-if="questionAnswers">{{ currentIndex + 1 }} of {{ questionAnswers.length - 1 }}</span>
      <button id="nextButton" class="mobile-pagination" name="Next" v-on:click="nextMobileQuestion()">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
    <!--pagination code-->
    <!-- download button start -->
    <div v-if="showDownloadVideoScreen" class="Rectangle">
      <div class="download-video">
        <div class="dwnd">
          <span class="download-contant">Your video is ready for download</span>
        </div>
        <br />
        <div class="download-cancle dwnd" style="margin-left: 43%">
          <a href="Cancel" style="text-decoration-line: none">Cancel</a>
        </div>
      </div>
    </div>
    <!-- download button end -->
  </div>
</template>

<script>
import jspdf from "jspdf";
import swal from "sweetalert2";
import html2canvas from "html2canvas";
import _ from "lodash";
import $ from "jquery";
import dsSlider from "../../lib/ds-slider-component";

export default {
  name: "activitydevice",
  data() {
    return {
      isLeaving: false,
      isProcessTerminated: false,
      isProcessingExport: false,
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      piecewiseActiveStyle: {},
      labelActiveStyle: {},
      showTablet: false,
      showDownloadVideoScreen: false,
      id: null,
      activityId: null,
      addQuestion: false,
      scaleValueInfoDiv: false,
      sequence: 1,
      currentIndex: 0,
      phoneQuestion: null,
      nextQuestion: null,
      questionAnswers: [],
      isQuestionInEditMode: false,
      displayOnlyTitleSteps: ["Index", "Log"],
      stopExporting: false
    };
  },
  components: {
    dsSlider
  },
  props: ["activityData", "intrupted"],
  computed: {
    questionSaveUpdateChanged() {
      return this.$store.getters.getNewActivityQuestion;
    },
    selectedActivityQuestionChanged() {
      return this.$store.getters.getActivitySelectedQuestion;
    },
    activityQuestions() {
      return this.$store.getters.getActivityQuestionsData;
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.isProcessing);
    this.activityId = this.activityData.id;
    this.questionAnswers = [];
    for (let i = 0; i < this.activityData.questions.length; i++) {
      if (this.activityData.questions[i].type && this.activityData.questions[i].type != "Section") {
        this.questionAnswers.push(this.activityData.questions[i]);
      }
    }
    this.phoneQuestion = this.questionAnswers[this.currentIndex];
  },
  watch: {
    isProcessingExport: {
      handler(val) {
        this.$emit("isProcessing", val);
      }
    },
    intrupted: {
      handler(val) {
        if (val) {
          this.isIntrupted();
        }
      }
    },
    activityQuestions: {
      handler(val) {
        this.questionAnswers = val;
      }
    }
  },
  methods: {
    isIntrupted() {
      swal({
        title: "Are you sure you want to leave this page and stop the current request in progress?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e0e0e0",
        cancelButtonColor: "#4c8ce4",
        confirmButtonText: "Cancel",
        cancelButtonText: "Continue"
      }).then(({ dismiss }) => {
        //If I hit continue button
        if (dismiss === "cancel") {
          this.stopExporting = true;
          this.isProcessingExport = false;
          this.$emit("resetIntrupt", false);
          this.$emit("isProcessing", false);
        } else {
          this.$emit("resetIntrupt", false);
          this.isProcessingExport = true;
        }
      });
    },
    vasModalWidthFind(width) {
      if (width <= 65 && width >= 25) {
        return width + 10 + "mm";
      } else if (width <= 25) {
        return width + 25 + "mm";
      }
    },
    toggleTablet(val) {
      if (val == "phone") {
        this.showTablet = false;
      } else {
        this.showTablet = true;
      }
    },
    exportSurveyPdf() {
      this.stopExporting = false;
      this.isProcessingExport = true;
      this.generateSurveyPdf().then(pdf => {
        if (this.isProcessingExport) {
          let filename = "activity_" + this.activityId + ".pdf";
          pdf.save(filename);
          this.isProcessingExport = false;
        }
      });
    },
    async generateSurveyPdf() {
      let val;
      if (this.showTablet == true) {
        val = "#tablet-frame";
      } else {
        val = "#phone-frame";
      }
      return new Promise(async resolveComplete => {
        let pdf = new jspdf("p", "px", "a4");
        for (let i = 0; i < this.questionAnswers.length - 1; i++) {
          if (this.stopExporting) {
            return;
          }
          await new Promise(async resolve => {
            this.nextMobileQuestionwithindex(i);
            await this.$nextTick();
            window.scrollTo(0, 0);
            html2canvas(document.querySelector(val), {
              allowTaint: true,
              useCORS: true,
              scale: 2
            }).then(canvas => {
              if (val == "#phone-frame") {
                pdf.addImage(canvas.toDataURL("image/png"), "PNG", 50, 50, 312, 360, "", "FAST");
              } else {
                pdf.addImage(canvas.toDataURL("image/png"), "PNG", 40, 20, 420, 420, "", "FAST");
              }
              if (i < this.questionAnswers.length - 2) {
                pdf.addPage("a4", "p");
              }
              resolve();
            });
          });
        }
        resolveComplete(pdf);
      });
    },
    nextMobileQuestionwithindex(newIndex) {
      if (newIndex < this.questionAnswers.length - 1) {
        this.currentIndex = newIndex;
        this.phoneQuestion = this.questionAnswers[newIndex];
      }
    },
    exportScreen() {
      let device;
      this.isProcessingExport = true;
      if (this.showTablet == true) {
        device = "tablet-frame";
      } else {
        device = "phone-frame";
      }
      let activityId = this.activityId;
      let container = document.getElementById(device);
      window.scrollTo(0, 0);
      new Promise((resolve, reject) => {
        html2canvas(container, {
          allowTaint: true,
          useCORS: true,
          scale: 1
        }).then(function(canvas) {
          element => false;
          // CacheStorage=false;
          let link = document.createElement("a");
          document.body.appendChild(link);
          let filename = "activity_" + activityId + ".png";
          link.download = filename;
          link.href = canvas.toDataURL("image/png");
          link.target = "_blank";
          link.click();
          resolve();
        });
      }).then(res => {
        this.isProcessingExport = false;
      });
    },
    printScreen() {
      let val;
      this.isProcessingExport = true;
      if (this.showTablet == true) {
        val = "#tablet-frame";
      } else {
        val = "#phone-frame";
      }
      let container = document.querySelector(val);

      new Promise((resolve, reject) => {
        html2canvas(container, { allowTaint: true, useCORS: true, scale: 2 }).then(function(canvas) {
          element => false;
          let dataURL = canvas.toDataURL();
          let width = canvas.width;
          let printWindow = window.open("");
          resolve();
          $(printWindow.document.body)
            .html("<img id='Image' src=" + dataURL + " style='" + width + "'></img>")
            .ready(function() {
              printWindow.focus();
              printWindow.print();
            });
        });
      }).then(res => {
        this.isProcessingExport = false;
      });
    },
    async printSurvey() {
      this.isProcessingExport = true;
      this.generateSurveyPdf().then(pdf => {
        if (this.isProcessingExport) {
          pdf.autoPrint();
          // pdf.output('dataurlnewwindow');
          window.open(pdf.output("bloburl"), "_blank");
          this.isProcessingExport = false;
        }
      });
    },
    nextMobileQuestion() {
      if (this.currentIndex < this.questionAnswers.length - 2) {
        this.currentIndex++;
        this.phoneQuestion = this.questionAnswers[this.currentIndex];
      }
    },
    prevMobileQuestion() {
      if (this.currentIndex != 0) {
        this.currentIndex--;
        this.phoneQuestion = this.questionAnswers[this.currentIndex];
      }
    },
    getPlaceHolderText(phoneQuestion) {
      if (phoneQuestion.showDate && !phoneQuestion.showTime) {
        return "Enter a date";
      } else if (phoneQuestion.showTime && !phoneQuestion.showDate) {
        return "Enter a time";
      } else {
        return "Enter a date and a time";
      }
    },
    getPlaceHolderTextMeasurement(phoneQuestion) {
      if (phoneQuestion.subType == "weight") {
        return "Enter weight";
      } else if (phoneQuestion.subType == "height") {
        return "Enter height/length";
      } else if (phoneQuestion.subType == "bloodpressure") {
        return "Enter blood pressure";
      } else if (phoneQuestion.subType == "measurements") {
        return "Enter value here";
      } else if (phoneQuestion.subType == "temperature") {
        return "Enter temperature";
      }
    },
    getDefaultPositionValueForCustomScale(phoneQuestion) {
      let defaultPointerPosition = phoneQuestion.defaultPointerPosition;
      if (defaultPointerPosition == "none" || defaultPointerPosition == "left") {
        return phoneQuestion.formattedLabels[0];
      } else if (defaultPointerPosition == "right") {
        return phoneQuestion.formattedLabels[phoneQuestion.formattedLabels.length - 1];
      } else if (defaultPointerPosition == "middle") {
        let l = phoneQuestion.formattedLabels.length;
        if (l % 2 == 0) {
          const halfLength = l / 2;
          return phoneQuestion.formattedLabels[halfLength - 1];
        } else {
          return phoneQuestion.formattedLabels[(l - 1) / 2];
        }
      } else {
        return phoneQuestion.formattedLabels[0];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tags-page {
  font-family: "RobotoRegular";

  &__back-to-activites {
    color: #4c8ce4;
  }

  .container {
    max-width: 90%;
  }

  &__header {
    /* max-width: 90%; */
    margin: 100px auto 0 auto;

    &__add-tag-btn {
      width: 116px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
    }
  }

  .manage-tags-text {
    /* width: 105px; */
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-tags-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }

  .add-tag-modal {
    .modal-dialog {
      vertical-align: top !important;
      top: 100px;
    }

    &__container {
      width: 902px;
      height: 219px;
      border-radius: 4px;
      background-color: #ffffff;

      .fw-bold {
        font-weight: bold;
      }

      .color-black {
        color: black;
      }
    }

    &__name-input {
      width: 220px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__desc-input {
      width: 549px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__add-another-tag {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #4c8ce4;
      cursor: pointer;
    }

    &__save-tag-btn {
      width: 102px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      color: white;
    }
  }
}
a.disabled-footer {
  pointer-events: none;
  cursor: default;
}
.top-content-name {
  color: #000000;
  display: inline-block;
  width: 95%;
}
.tablet-dropdown {
  font-family: Roboto;

  font-size: 18px;

  font-weight: bold;

  font-stretch: normal;

  font-style: normal;

  line-height: 1.11;

  letter-spacing: normal;

  color: #666669;
}
.dropdown-toggle {
  cursor: pointer;
  font-family: RobotoBold;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
}

.phone-next-button {
  background-color: #576a6e;
  border: none;
  color: white;
  padding: 8px 21px;
  cursor: pointer;
  font-size: 15px;
  border-radius: 15px;
  width: 80%;
  margin-left: 45px;
}

.tablet-next-button {
  background-color: #576a6e;
  border: none;
  color: white;
  padding: 8px 21px;
  cursor: pointer;
  font-size: 15px;
  border-radius: 15px;
  width: 75%;
  margin-left: 60px;
}

.dwnd {
  align-items: center;
  display: flex;
  justify-content: center;
}
.Rectangle {
  width: 425px;
  height: 878px;
  background-color: rgba(196, 196, 196, 0.2);
}
.download-cancle {
  width: 43px;
  height: 20px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}

.download-btn {
  width: 136px;
  cursor: pointer;
  height: 30px;

  background-color: #4c8ce4;
}
.download-txt {
  width: 99px;
  height: 16px;
  padding: 5px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #ffffff;
}

.vertical-vue-slider {
  height: auto;
}

.download-contant {
  width: 290px;
  margin-top: 308px;
  height: 20px;
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #000000;
}

.Export {
  width: 41px;
  height: 20px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
}
.Phone {
  width: 52px;
  height: 20px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.11;
  letter-spacing: normal;
  color: #666669;
  margin-top: 50px;
}

.add_Preview_btn {
  width: 148px;
  height: 36px;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  background-color: #ffffff;
}
.Content {
  width: 99px;
  height: 20px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.Ellipse {
  width: 30px;
  height: 30px;
  background-color: #4c8ce4;
}

body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
  .col-lg-offset-4 {
    margin-left: 33.33333333%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

h1,
h2,
h3 {
  font-weight: 200;
}

.wong-baker-title-text {
  font-family: Roboto;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.42;
  color: #4a4a4a;
}

.wong-baker-count-box {
  width: 50px;
  height: 59px;
  padding: 19px 17px;
  margin: 25px auto;
  border-radius: 8px;
  border: solid 1px #b0bac9;
}
.wong-baker-count-box .count-text {
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #666669;
}
.phone-frame1 {
  border-radius: 29px;
  width: 308px;
  height: 554px;
  margin: 12% auto 0 auto;
  // margin-top: 12%;
  background-color: rgba(216, 216, 216, 0.4);
}
.phone-inner-part {
  border-radius: 8px;
  width: 294px;
  height: 507px;
  background-color: white;
  margin-left: 7px;
  margin-top: 1px;
  position: relative;
  top: 15px;
}
.phone-top-bar {
  height: 21px;
  padding: 5px;
  // background-color: black;
}
.tablet-frame1 {
  border-radius: 19px;
  width: 365px;
  height: 519px;
  margin: 12% auto 0;
  background-color: rgba(216, 216, 216, 0.4);
}
.tablet-inner-part {
  border-radius: 8px;
  width: 345px;
  height: 470px;
  background-color: white;
  margin-left: 10px;
  margin-top: 3px;
  position: relative;
  top: 15px;
}

.tablet-inner-part .bs-example-modal .modal-body {
  height: auto;
  overflow: hidden;
}

.question-body {
  width: 355px;
  height: 350px;
}

.form-control {
  border-radius: 2px;
}

.pr-0 {
  padding-right: 0;
}

.pl-0 {
  padding-left: 0;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}

.button-blue-1 {
  background: #00bae0;
  color: #fff;
}

.button-blue-2 {
  background-color: #0197eb;
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.first_question_selection {
  img {
    width: 100%;
    max-width: 100px;
  }
  .header {
    font-size: 24px;
    font-weight: 200;
    padding: 14px;
  }
  .label_text {
    font-size: 18px;
    padding-bottom: 10px;
    font-weight: 400;
  }
  select {
    margin: auto;
    width: 100%;
    max-width: 300px;
  }
}

.question_count {
  background-color: #34537d;
  color: #fff;
  width: 25px;
  display: inline-block;
  border-radius: 10px;
  text-align: center;
}

.inner-card {
  border: 1px solid #ddd;
  box-shadow: 1px 0px 1px 1px #ddd;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f6fafc;
}

.select-style {
  background: #f9f9f9;
  border-radius: 2px;
}

.radio-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
}

.check-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
  padding: 0px 20px;
}

.border-left {
  border-left: 1px solid #555555;
}

.container-style {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.container-stylee {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  width: 29% !important;
  max-width: 29% !important;
  right: 0;
}

.input-style {
  width: 45px;
  margin-left: 10px;
  background: #f9f9f9;
  display: initial;
  padding: 5px;
}

.char-style {
  font-size: 14px;
  color: #555555;
}

.card {
  padding: 15px;
  color: black;
}

.add_another_btn {
  width: 136px;
  border-color: #4c8ce4;
  margin-bottom: 20px;
  background-color: #4c8ce4;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;

  .fa {
    position: relative;
    left: -35px;
    pointer-events: none;
    color: #4c8ce4;
    background-color: #fff;
    border-color: #fff;
  }
}

.preview-btn {
  background-color: #d4f2ff;
  width: 100%; // max-width: 150px;
  padding: 10px 0;
}

.icon-style {
  font-size: 47px;
  position: absolute;
  left: 30px;
  /* bottom: 0px; */
  top: -25px;
}

.pl-25 {
  padding-left: 25px;
}

@media (max-width: 575px) {
  .container-padding {
    padding-left: 20px;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
}

@media (min-width: 768px) and (max-width: 991px) {
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 1200px) {
}

.back_link {
  color: #666669;
}

.btn-new {
  width: 130px;
  height: 30px;
  background-color: #4c8ce4;
  border: none;
  border-radius: 100px;
}

.btn-preview {
  background-color: #4c8ce4;
  border: none;
  border-radius: 100px;
}

.show-btn-preview {
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
  color: #4c8ce4;
}

.circle {
  width: 24px;
  height: 24px;
  background-color: #fff;
  position: relative;
  left: -16px;
  top: -3px;
  color: #4c8ce4;
  font-weight: bold;
  border-radius: 12px;
  font-size: 18px;
  padding: 0px 8px;
}

.show-circle {
  background-color: #b0bac9;
  position: relative;
  left: -8px;
  top: 0px;
  color: #ffffff;
  font-weight: bold;
  border-radius: 3px;
  font-size: 18px;
  padding: 5px 10px;
}

.hide-circle {
  width: 30px;
  height: 30px;
  background-color: #fff;
  position: relative;
  left: -8px;
  top: 0px;
  color: #4c8ce4;
  font-weight: bold;
  border-radius: 20px;
  font-size: 18px;
  padding: 5px 10px;
}

.txt {
  position: relative;
  color: #fff;
  left: -10px;
  top: -5px;
  font-size: 12px;
}
.hide-txt {
  position: relative;
  color: #fff;
  left: -5px;
  top: -2px;
  font-size: 14px;
}

.show-txt {
  position: relative;
  color: #4c8ce4;
  left: -5px;
  top: -2px;
  font-size: 14px;
  line-height: 1.43;
}
#questionbpodyy {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  > div {
    flex: 1 1 auto;

    &:first-child {
      height: 230px;
      overflow: hidden auto;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  &.phone-question {
    > div {
      &:first-child {
        height: 260px;
      }
    }
  }

  &.no-footer {
    > div {
      &:first-child {
        height: 318px;
      }
    }
  }
}
.phone-question {
  height: 350px;
  max-height: 350px;
  position: relative;
}
/deep/ .custom-footer {
  bottom: 0;
  width: 100%;
  text-align: center;
  height: 80px;
  word-break: break-word;
  text-align: center;
  overflow: hidden;
  z-index: 99;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    margin-bottom: 0;
  }
}
.phone-question-footer {
  height: auto;
  z-index: 2;
  position: relative;
}
.tablet-question {
  height: 318px;
  max-height: 318px;
  position: relative;
  overflow: hidden auto;
}
.tablet-question-footer {
  height: auto;
  z-index: 10;
  position: relative;
}
.tablet-question-footer .next-button {
  width: 80%;
  border-radius: 10px;
}
.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}
.instruction_title {
  word-break: keep-all;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}
.instruction_info {
  word-break: keep-all;
  height: auto;
  overflow: hidden;
}

.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
  .col-sm-3 {
    float: left;
  }
}

.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.date-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.next-button {
  background-color: #4c6473;
  color: #fff;
  margin: 0 auto;
  display: block;
  width: 80%;
  border-radius: 10px;
}
.mobile-pagination {
  padding: 5px 10px 5px 10px;
  margin-bottom: 20px;
  border: 1px solid #e6e5e5;
  color: #bdbdbd;
}
.preview-footer {
  margin-top: 5%;
  z-index: 1000;
  position: relative;
}
.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}
.modal-title {
  font-size: 24px !important;
}
.modal-dialog {
  width: 100%;
}
.bs-example-modal .modal-body {
  overflow: hidden;
}
.bs-example-modal .modal-header {
  padding: 0rem 1rem;
  display: block !important;
}
.bs-example-modal .modal-dialog {
  margin: 0rem auto;
}
.phoneBar {
  font-family: RobotoBold;
  font-size: 18px;
  font-weight: bold;
  color: #666669;
  background-color: white;
  border: none;
  width: auto;
  padding-right: 10px;
}

.phoneTabletMenu .dropdown-toggle::after {
  margin-left: 5px;
}
.phoneTabletMenu .dropdown-toggle::after {
  margin-left: 5px;
  vertical-align: middle;
}
.exportBtn .dropdown-toggle::after {
  font-size: 18px;
  vertical-align: middle;
}
.phoneBar:focus {
  outline: #eee0 auto 1px;
  box-shadow: none;
}
.exportDropdown .dropdown-item {
  padding: 7px;
  font-family: RobotoRegular;
}
.exportDropdown .dropdown-item .fa,
.exportDropdown .dropdown-item .fa {
  color: #a8b0b4;
  margin-right: 5px;
}
.dropdown-item:hover {
  cursor: pointer;
}
.dropdown-item:ac {
  cursor: pointer;
}
.phone-tablet-menu .fa {
  margin-right: 10px;
}
.dropdown-menu {
  box-shadow: 0 0 0.5rem rgba(108, 118, 134, 0.5);
  min-width: 9rem;
}
.phone-tablet-menu a {
  padding: 5px 10px;
}
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #545b62;
}
.imageBox {
  height: 80px;
  width: 80px;
  margin: 0 auto;
}
.vas-minValueLabel {
  max-width: 50%;
  width: auto;
  display: inline-block;
  height: auto;
  float: left;
  word-wrap: break-word;
}
.vas-maxValueLabel {
  max-width: 50%;
  width: auto;
  display: inline-block;
  height: auto;
  float: right;
  word-wrap: break-word;
  margin-left: 0 !important;
  padding-left: 20px;
  text-align: right;
}
.phone-tooltip {
  height: 14px;
  width: 14px;
  position: relative;
  top: 14px;
  left: 14px;
  z-index: 20;
  margin-right: 10px;
}
.wong-baker-smiley {
  margin: 0 auto;
  max-width: 50px;
}
/deep/ .step-img-format {
  img {
    max-width: 120px;
    max-height: 120px;
  }
}
/deep/ .ql-editor {
  height: auto;
  min-height: 0px;
  word-break: keep-all !important;
  word-wrap: normal !important;
  display: block;
  overflow: scroll;
}
p.ql-align-right {
  text-align: right;
  float: none !important;
}
.label {
  width: 100%;
  max-width: 55px;
}
.v-number-scale-steps {
  height: 300px !important;
}
.wordbrk {
  word-break: break-all;
  text-align: center;
}
.vas_result_label {
  position: absolute;
  left: 0;
  top: 26%;
  width: 125px;
  text-align: center;
  margin-left: 2px;
  word-break: break-all;
  border: 1px solid #4c6473;
  height: 132px;
  overflow: hidden;
  padding: 5px;
  font-size: 12px;
  padding-top: 12%;
}
.vas_result_label span {
  vertical-align: middle;
  word-spacing: 100px;
}
.drop-down {
  height: 42px;
  width: 100%;
  margin-bottom: 10px;
}
</style>
